// extracted by mini-css-extract-plugin
export var contentWrapper = "BulletinBoardSection-module--contentWrapper--eb390";
export var imageHolder = "BulletinBoardSection-module--imageHolder--19fcd";
export var innerWrapper = "BulletinBoardSection-module--innerWrapper--b6ea3";
export var newsImageHolder = "BulletinBoardSection-module--newsImageHolder--2f3c7";
export var title = "BulletinBoardSection-module--title--0bfdb";
export var titleWrapper = "BulletinBoardSection-module--titleWrapper--7a00f";
export var wrapper = "BulletinBoardSection-module--wrapper--62d31";